import { render, staticRenderFns } from "./ListeReglements.vue?vue&type=template&id=264bf879&"
import script from "./ListeReglements.vue?vue&type=script&lang=js&"
export * from "./ListeReglements.vue?vue&type=script&lang=js&"
import style0 from "./ListeReglements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports